<template>
	<div id="breaches-panel" class="container panel" v-tooltip-container>
		<div class="row">
			<div class="col-md-3 sidebar">
				<side-bar></side-bar>
			</div>

			<div class="col-md-9 content">
				<dash-head class="mb-3" title="Breaches" subtitle="Password Security Portal"></dash-head>		

				<table-actions placeholder="search breaches" @search-changed="searchChanged" hideEdit="true" hideDelete="true">
				</table-actions>
				
				<table-view id="breaches-results">
					<table-row slot="header">
						<table-header @click-header="sortByDate" sort="descending">Date</table-header>
						<table-header @click-header="sortByName" sort="none">Name</table-header>
        				<table-header>Description</table-header>
						<table-header>Type</table-header>
						<table-header @click-header="sortByStatus" sort="none">Status</table-header>
					</table-row>
					<table-row slot="body" v-for="result in results" :key="result.rowKey" :class="{selected: result === resultFound}">
						<table-cell>{{result.date.toLocaleDateString()}}</table-cell>
						<table-cell>{{result.name}}</table-cell>
						<table-cell>{{result.description}}</table-cell>
						<table-cell>{{result.type}}</table-cell>
						<table-cell><status-tooltip :status="result.status"></status-tooltip></table-cell>
					</table-row>
				</table-view>

				<div class="row">
					<div class="col-md-6">
						<table-pagination :page="page" :total="totalRows" :pageSize="pageSize" @page-changed="pageChanged"></table-pagination>
					</div>
					<div class="col-md-6">
						<div class="text-right">
						</div>
					</div>
				</div>

			</div>
		</div>	
	</div>
</template>

<script>
	import SideBar from './SideBar'
	import DashHead from './DashHead'
	import TableActions from './TableActions'
	import TableView from './TableView'
	import TableRow from './TableRow'
	import TableHeader from './TableHeader'
	import TableCell from './TableCell'
	import TablePagination from './TablePagination'
	import StatusTooltip from './StatusTooltip'

	import api from '../api'
	import router from '../router'
	import store from '../state'

	export default {
		name: 'BreachesPanel',
		props: ['pageSize'],
		components: {SideBar, DashHead, TableActions, TableView, TableRow, TableHeader, TableCell, TablePagination, StatusTooltip},
		data() {
			return {
				error: null,
				resultFound: null,
				search: '',
				page: 1
			}
		},
		methods: {
			sortByDate(direction) {
				this.sortByPropertyNumeric(direction, 'date');				
			},
			sortByName(direction) {
				this.sortByProperty(direction, 'name');
			},
			sortByStatus(direction) {
				this.sortByProperty(direction, 'status');
			},
			sortByProperty(direction, name) {		
				const data = this.breaches;

				if (direction === 'ascending') {
					data.sort(function (a,b) {
						if (a[name] === b[name]) return 0;
						return (a[name] > b[name]) ? 1 : -1;
					});
				}
				else {
					data.sort(function (a,b) {
						if (b[name] === a[name]) return 0;
						return (b[name] > a[name]) ? 1 : -1;
					});

				}
				this.page = 1;
			},
			sortByPropertyNumeric(direction, name) {			
				const data = this.breaches;

				if (direction === 'ascending') {
					data.sort((a,b) => a[name] - b[name]);
				}
				else {					
					data.sort((a,b) => b[name] - a[name]);
				}
				this.page = 1;
			},
			searchChanged(value) {
				this.search = value.toLowerCase();
				this.page = 1;

				return;
			},
			pageChanged(value) {
				this.page = value;
			}
		},
		computed: {
			totalRows() {
				return this.filteredBreaches.length;
			},
			breaches() {
				return store.state.sources;
			},
			filteredBreaches() {
				if (!this.breaches) return [];
				if (!this.search) return this.breaches;
				return this.breaches.filter(value => value.name.includes(this.search) || value.description.includes(this.search));
			},
			results() {
				const start = (this.page-1) * this.pageSize;		
				const results = [];								

				for (var breach of this.filteredBreaches.slice(start, start + this.pageSize)) {
					results.push(breach);
				}

				return results;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/BreachesPanel.vue